// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/_global.sass
// module id = 842
// module chunks = 1